import { ResponsiveImage } from "@/components/ResponsiveImage";

export const PageHero = ({ eyebrow, title, intro, image, imageAlt, children }) => (
  <section className="page-hero">
    <div className="page-shell page-hero-grid">
      <div className="page-hero-copy page-enter"><span className="kicker">{eyebrow}</span><h1>{title}</h1><p>{intro}</p>{children}</div>
      {image && <div className="page-hero-media page-enter"><ResponsiveImage slug={image} alt={imageAlt || title} sizes="(max-width: 760px) 100vw, 50vw" eager testId="page-hero-image" /></div>}
    </div>
  </section>
);
